/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SettingManagementDeleteSettingResponse } from './SettingManagementDeleteSettingResponse';

export type SettingManagementDeleteSettingResponseApiRespoonse = {
    data?: SettingManagementDeleteSettingResponse;
    status?: SettingManagementDeleteSettingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace SettingManagementDeleteSettingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

